export default "__VITE_ASSET__04073f93__"